<template>

    <div class="layout-container">
        <!-- 菜单tree -->
        <div class="layout-nav"
             ref="layoutNav">
            <div v-if="!isEditMode">
                <div class="doc-nav-title">
                    <span>{{title||'帮助文档'}}</span>
                    <!-- <a-tooltip placement="top">
                        <a-icon type="file-pdf"
                                class="menu-export-icon"
                                title="导出为pdf"
                                @click="exportPDF" />
                    </a-tooltip> -->
                </div>
                <div class="doc-nav-tree"
                     :style="{height:(navHeight - 50)+'px'}">
                    <div class="doc-nav-search">
                        <a-input-search v-model="searchValue"
                                        style="100%"
                                        placeholder="输入关键字查询"
                                        size="small"
                                        @search="onInputSearch" />
                    </div>
                    <div class="doc-nav-menu">
                        <a-menu mode="inline"
                                style="width: 220px"
                                class="top-menu"
                                :selected-keys="menuselectedDirKeys"
                                :defaultOpenKeys="menuOpenKeys"
                                @select="selectedMenuHandle">
                            <!-- 第一层 -->
                            <template v-for="item in menudirTreeData">
                                <a-sub-menu v-if="item.children && item.children.length > 0"
                                            :key="item.id"
                                            :title="item.title">
                                    <!-- 第二层 -->
                                    <template v-for="subItem in item.children">
                                        <a-sub-menu v-if="subItem.children && subItem.children.length > 0"
                                                    :key="subItem.id"
                                                    :title="subItem.title">
                                            <!-- 第三层 -->
                                            <template v-for="sub3Item in subItem.children">
                                                <a-sub-menu v-if="sub3Item.children && sub3Item.children.length > 0"
                                                            :key="sub3Item.id"
                                                            :title="sub3Item.title">
                                                    <!-- 第四层 -->
                                                    <a-menu-item v-for="sub4Item in sub3Item.children"
                                                                 :key="sub4Item.id"><span>{{sub4Item.title}}</span></a-menu-item>
                                                </a-sub-menu>
                                                <a-menu-item v-else
                                                             :key="sub3Item.id"><span>{{sub3Item.title}}</span></a-menu-item>
                                            </template>
                                        </a-sub-menu>
                                        <a-menu-item v-else
                                                     :key="subItem.id"><span>{{subItem.title}}</span></a-menu-item>
                                    </template>
                                </a-sub-menu>
                                <a-menu-item v-else
                                             :key="item.id"><span>{{item.title}}</span></a-menu-item>
                            </template>
                        </a-menu>
                    </div>
                </div>
            </div>
            <left-menu v-else
                       ref="leftMenu"
                       @select="selectedMenuHandle"
                       @updateMain="updateBreadcrumb" />
        </div>
        <!-- markdown文档 -->
        <div class="layout-content">
            <div class="custom-markdown">
                <div class="custom-breadcrumbs">
                    <div class="custom-breadcrumb">
                        <span>当前路径：</span>
                        <a-breadcrumb>
                            <a-breadcrumb-item v-for="(item,index) in breadcrumb"
                                               :key="index"><span style="font-size:14px;">{{item.title}}</span></a-breadcrumb-item>
                        </a-breadcrumb>
                    </div>
                    <div class="edit-panel"
                         v-if="isDevelop||(!isDevelop&&hasEditAuthority.includes(userAccount))">
                        <!-- <a-button type="link"
                                  icon="export"
                                  v-if="!isEditMode"
                                  style="font-size:14px"
                                  @click="exportSinglePDF(true)">导出PDF</a-button> -->
                        <a-button type="link"
                                  icon="edit"
                                  v-if="!isEditMode"
                                  style="font-size:14px"
                                  @click="switchEditMode(true)">编辑文档</a-button>
                        <a-button type="link"
                                  icon="save"
                                  v-if="isEditMode"
                                  style="font-size:14px"
                                  @click="saveMarkdown">保存</a-button>
                        <a-button type="link"
                                  v-if="isEditMode"
                                  icon="close"
                                  style="font-size:14px"
                                  @click="switchEditMode(false)">取消</a-button>
                    </div>
                </div>
                <div class="markdown-container">
                    <mavon-editor ref="md"
                                  v-model="mdValue"
                                  class="markdown-body"
                                  :fontSize="'13px'"
                                  :toolbars="toolbars"
                                  @imgAdd="$imgAdd"
                                  :default-open="modeConfig.defaultOpen"
                                  :subfield="modeConfig.subfield"
                                  :boxShadow="modeConfig.boxShadow"
                                  :navigation="modeConfig.navigation"
                                  :toolbarsFlag="modeConfig.toolbarsFlag"
                                  :externalLink="modeConfig.externalLink" />
                    <!-- <div class="markdown-menu-container"></div> -->
                    <div class="markdown-footer">
                        <a-button type="link"
                                  @click="pageTurn('pre')"
                                  :disabled="!(!!pageData.pre)">
                            {{`&lt; 上一篇${pageData.pre?'：'+pageData.pre:''}`}}
                        </a-button>
                        <a-button type="link"
                                  @click="pageTurn('next')"
                                  :disabled="!(!!pageData.next)">
                            {{`下一篇${pageData.next?'：'+pageData.next:''} >`}}
                        </a-button>
                    </div>
                </div>
            </div>
        </div>
        <!-- 上传图片 -->
        <a-modal v-model="addImgShow"
                 title="上传图片"
                 :width="630">
            <div class="operator-item-div">
                <a-form-model ref="selectImgDir"
                              layout="inline"
                              :model="imgDirForm"
                              :rules="dirRule"
                              :label-col="{span:5}"
                              :wrapper-col="{span:19}">
                    <a-form-model-item style="width: 400px;margin-bottom:20px;"
                                       label="图片名称">
                        <a-input v-model="imgDirForm.fileName"
                                 placeholder="请输入图片名称" />
                    </a-form-model-item>
                    <a-form-model-item style="width: 400px;margin-bottom:20px;"
                                       label="选择文件夹">
                        <a-directory-tree default-expand-all
                                          class="draggable-tree"
                                          @select="onDirTreeSelect"
                                          :tree-data="dirTreeData" />
                    </a-form-model-item>
                </a-form-model>
            </div>
            <template slot="footer">
                <!-- <a-button :disabled="!selectedDirKey || createDisable"
                          @click="createDir">新建文件夹</a-button> -->
                <a-button :disabled="!selectedDirKey"
                          @click="saveImg"
                          type="primary">保存</a-button>
            </template>
        </a-modal>
        <!-- 创建文件夹 -->
        <a-modal v-model="createDirForm"
                 title="新建文件夹"
                 okText="保存"
                 @ok="getDirName"
                 @cancel="dirNameReset"
                 cancelText="取消">
            <div class="operator-item-div">
                <a-form-model ref="editSubForm"
                              :model="dirForm"
                              :rules="dirRule"
                              :label-col="{span:4}"
                              :wrapper-col="{span:15}">
                    <a-form-model-item label="名称"
                                       class="marginbot20"
                                       prop="dirName">
                        <a-input v-model.trim="dirForm.dirName"
                                 :maxLength="10"
                                 placeholder="请输入文件夹名称" />
                    </a-form-model-item>
                </a-form-model>
            </div>
        </a-modal>
    </div>
</template>

<script>
import qs from 'qs'
import leftMenu from '@/views/components/left-menu.vue'
import { Base64 } from 'js-base64'
// const db = require('../../public/server/db/db.json')
export default {
    name: 'MainItem',
    components: {
        leftMenu
    },
    data () {
        return {
            dbData: {},
            addDirPath: [], // 存放新建文件夹的地址
            dirTreeData: [], // 图片文件夹菜单
            selectedDirKey: '', // 选中的图片文件夹
            createDirForm: false,
            addImgShow: false,
            imgDirForm: {
                selectedDir: '',
                fileName: ''
            },
            dirForm: {
                dirName: ''
            },
            dirRule: {
                dirName: {
                    validator: (rule, value, callback) => {
                        if (!value.trim()) {
                            return callback('该字段不能为空')
                        }
                        if (value.trim().length > 10) {
                            this.dirForm.fileName = value.slice(0, 10)
                        }
                        const reg = new RegExp(/^[\u4e00-\u9fa5_a-zA-Z0-9]{1,10}$/)
                        if (!reg.test(value.trim())) {
                            callback('文件名格式不正确')
                        } else {
                            callback()
                        }
                    },
                    trigger: 'blur'
                }
            },
            file: null, // 上传图片
            pos: null, // 编辑器中图片的位置
            imgDirList: [], // 保存图片的文件夹位置
            menudirTreeData: [], // 当前帮助文档菜单
            menuselectedDirKeys: [], // 选中菜单
            breadcrumb: [],
            isDevelop: false, // 是否是开发环境
            isEditMode: false, // md是否是编辑模式
            mdValue: null, // markdown
            modeConfig: {
                defaultOpen: 'preview',
                subfield: false,
                boxShadow: false,
                toolbarsFlag: false,
                navigation: true,
                // externalLink: false
                externalLink: {
                    markdown_css: function () {
                        // 这是你的markdown css文件路径
                        return require('../../public/mavon-editor/css/updataIndex.css')
                    }
                    // hljs_js: function () {
                    //     // 这是你的hljs文件路径
                    //     return require('../../public/mavon-editor/highlightjs/highlight.min.js')
                    // },
                    // hljs_css: function (css) {
                    //     // 这是你的代码高亮配色文件路径
                    //     return require('../../public/mavon-editor/highlightjs/styles/' + css + '.min.css')
                    // },
                    // hljs_lang: function (lang) {
                    //     // 这是你的代码高亮语言解析路径
                    //     return require('../../public/mavon-editor/highlightjs/languages/' + lang + '.min.js')
                    // },
                    // katex_css: function () {
                    //     // 这是你的katex配色方案路径路径
                    //     return require('../../public/mavon-editor/katex/katex.min.css')
                    // },
                    // katex_js: function () {
                    //     // 这是你的katex.js路径
                    //     return require('../../public/mavon-editor/katex/katex.min.js')
                    // }
                }
            },
            toolbars: {
                bold: true, // 粗体
                italic: true, // 斜体
                header: true, // 标题
                underline: true, // 下划线
                strikethrough: true, // 中划线
                mark: true, // 标记
                superscript: true, // 上角标
                subscript: true, // 下角标
                quote: true, // 引用
                ol: true, // 有序列表
                ul: true, // 无序列表
                link: true, // 链接
                imagelink: false, // 图片链接
                code: true, // code
                table: true, // 表格
                fullscreen: false, // 全屏编辑
                readmodel: false, // 沉浸式阅读
                htmlcode: false, // 展示html源码
                help: true, // 帮助
                undo: true, // 上一步
                redo: true, // 下一步
                trash: true, // 清空
                save: false, // 保存（触发events中的save事件）
                navigation: false, // 导航目录
                alignleft: true, // 左对齐
                aligncenter: true, // 居中
                alignright: true, // 右对齐
                subfield: false, // 单双栏模式
                preview: true // 预览
            },
            searchValue: '', // 搜索内容
            menuOpenKeys: [],
            title: '',
            navHeight: 0,
            currentMenuList: [], // 当前选中节点的同一层次节点
            currentMenu: {}, // 当前选中节点
            pageData: { // 分页信息
                pre: '',
                next: '',
                index: 0
            },
            hasEditAuthority: ['huzw', 'zhangt02', 'sunyx', 'lingh'] // 客户可编辑账户
        }
    },
    computed: {
        userAccount () {
            return this.$store.state.user.currentAccount
        },
        restUrl () {
            return this.$store.state.restUrl
        },
        createDisable () {
            return this.selectedDirKey.slice(2).split('-').length > 4
        }
    },
    created () {
        this.isDevelop = (process.env.NODE_ENV === 'development') // 是否是开发环境
        this.getdbData()
    },
    mounted () {
        this.$nextTick(() => {
            this.navHeight = this.$refs.layoutNav.clientHeight
        })
        window.addEventListener('resize', () => {
            this.navHeight = this.$refs.layoutNav.clientHeight
        })
    },
    methods: {
        parseDataSearch (data) {
            const menu = []
            const map = {}
            const cloneData = data
            cloneData.forEach(m => {
                m.children = []
                if (m.parentId === '0' || (!map[m.id] && !map[m.parentId])) {
                    menu.push(m) // 如果是根 就直接push到menu中
                } else {
                    map[m.parentId] && map[m.parentId].children.push(m)
                }
                map[m.id] = m // {1:菜单,2:菜单}
            })
            return menu
        },
        onInputSearch () {
            if (this.isDevelop) {
                fetch(this.restUrl + '/search' + `?content=${this.searchValue}`).then(response => response.json()).then(result => {
                    this.menudirTreeData = this.parseDataSearch(result || [])
                })
            } else {
                let value = []
                if (this.searchValue) {
                    this.dbData.map(item => {
                        if (item.title.includes(this.searchValue)) {
                            value.push(item)
                        }
                    })
                } else {
                    value = this.dbData
                }
                this.menudirTreeData = value
            }
        },
        updateBreadcrumb (name) {
            this.getdbData()
        },
        getdbData () {
            // if (this.isDevelop) {
            fetch(this.restUrl + '/list', {
                headers: {
                    Connection: 'keep-alive'
                }
            }).then(response => response.json()).then(result => {
                this.dbData = result
                const defaultMenu = this.$route.query.menuId
                if (defaultMenu) {
                    const defaulMenuObj = this.dbData.find(item => item.id === defaultMenu)
                    this.title = (defaulMenuObj && defaulMenuObj.title) || ''
                    const menu = []
                    const hasAdd = {}
                    this.menuOpenKeys.push(defaultMenu)
                    this.dbData.forEach(item => {
                        if (item.id === defaultMenu || item.parentId === defaultMenu || hasAdd[item.parentId]) {
                            hasAdd[item.id] = item
                            menu.push(item)
                            if (item.parentId && !this.menuOpenKeys.includes(item.parentId)) {
                                this.menuOpenKeys.push(item.parentId)
                            }
                        }
                    })
                    this.dbData = menu
                }
                this.initMenu()
            })
            // } else {
            //     this.dbData = db.docs
            //     const defaultMenu = this.$route.query.menuId
            //     if (defaultMenu) {
            //         const defaulMenuObj = this.dbData.find(item => item.id === defaultMenu)
            //         this.title = (defaulMenuObj && defaulMenuObj.title) || ''
            //         const menu = []
            //         const hasAdd = {}
            //         this.menuOpenKeys.push(defaultMenu)
            //         this.dbData.forEach(item => {
            //             if (item.id === defaultMenu || item.parentId === defaultMenu || hasAdd[item.parentId]) {
            //                 hasAdd[item.id] = item
            //                 menu.push(item)
            //                 if (item.parentId && !this.menuOpenKeys.includes(item.parentId)) {
            //                     this.menuOpenKeys.push(item.parentId)
            //                 }
            //             }
            //         })
            //         this.dbData = menu
            //     }
            //     this.initMenu()
            // }
        },
        initMenu () {
            this.menudirTreeData = this.parseData()
            if (this.menudirTreeData.length > 0) {
                let firtMenu = ''
                if (this.menudirTreeData[0].children.length > 0) {
                    firtMenu = this.menudirTreeData[0].children[0]
                    this.menuselectedDirKeys = [this.menudirTreeData[0].children[0].id]
                } else {
                    firtMenu = this.menudirTreeData[0]
                    this.menuselectedDirKeys = [this.menudirTreeData[0].id]
                }
                this.currentMenu = firtMenu
                // 获取markdown数据
                this.getMarkdownText()
                // 获取当前菜单路径
                const locationPath = this.getBreadcrumb(this.menudirTreeData, firtMenu.id)
                this.breadcrumb = locationPath.reverse()
                // 获取当前分页信息
                this.initPageData()
            }
        },
        parseData (data) {
            const menu = []
            const map = {}
            const cloneData = (data && data.length > 0) ? data : this.dbData
            cloneData.forEach(m => {
                m.children = []
                map[m.id] = m // {1:菜单,2:菜单}
                if (m.parentId === '0') {
                    menu.push(m) // 如果是根 就直接push到menu中
                } else {
                    map[m.parentId] && map[m.parentId].children.push(m)
                }
            })
            return menu
        },
        getBreadcrumb (data, id) {
            const arr1 = JSON.parse(JSON.stringify(data))
            // 获取当前路径
            var temp = []
            var forFn = function (arr, id) {
                for (var i = 0; i < arr.length; i++) {
                    var item = arr[i]
                    if (item.id === id) {
                        delete item.children
                        temp.push(item)
                        forFn(arr1, item.parentId)
                        break
                    } else {
                        if (item.children) {
                            forFn(item.children, id)
                        }
                    }
                }
            }
            forFn(arr1, id)
            return temp
        },
        getMarkdownText () {
            // if (this.isDevelop) {
            fetch(this.restUrl + '/doc/' + this.menuselectedDirKeys[0], {
                headers: {
                    Connection: 'keep-alive'
                }
            }).then(response => response.json()).then(result => {
                if (result.data) {
                    this.mdValue = Base64.decode(result.data)
                } else {
                    this.mdValue = '### 请开始编辑...'
                }
            })
            // } else {
            //     const value = db.maps[this.menuselectedDirKeys[0]]
            //     if (value) {
            //         this.mdValue = Base64.decode(value)
            //     } else {
            //         this.mdValue = '### 请开始编辑...'
            //     }
            // }
        },
        // 获取当前选中节点的同一层所有节点
        getCurrentMenuList (data, id) {
            const find = data.find(item => item.id === id)
            if (find) {
                this.currentMenuList = JSON.parse(JSON.stringify(data))
                return ''
            } else {
                for (const i in data) {
                    if (data[i].children && data[i].children.length > 0) {
                        this.getCurrentMenuList(data[i].children, id)
                    }
                }
            }
        },
        // 获取当前点击的菜单节点
        getCurrentMenu (data) {
            for (const i in data) {
                if (data[i].id === this.menuselectedDirKeys[0]) {
                    this.currentMenu = JSON.parse(JSON.stringify(data[i]))
                    return
                } else {
                    if (data[i].children && data[i].children.length > 0) {
                        this.getCurrentMenu(data[i].children)
                    }
                }
            }
        },
        selectedMenuHandle (item, loadMenuList) {
            this.menuselectedDirKeys = [item.key]
            this.getCurrentMenu(this.menudirTreeData)
            // 获取markdown数据
            this.getMarkdownText()
            // 获取当前菜单路径
            const locationPath = this.getBreadcrumb(this.menudirTreeData, this.menuselectedDirKeys[0])
            this.breadcrumb = locationPath.reverse()
            if (this.currentMenu.children && this.currentMenu.children.length > 0) {
                this.pageData.index = 0
                this.pageData.pre = ''
                this.pageData.next = ''
            } else {
                this.initPageData(loadMenuList)
            }
        },
        // 初始化翻页数据
        initPageData (loadMenuList) {
            if (!loadMenuList) {
                this.getCurrentMenuList(this.menudirTreeData, this.menuselectedDirKeys[0])
                this.currentMenuList = this.currentMenuList.filter(item => !item.children || item.children.length === 0)
            }
            const index = this.currentMenuList.findIndex(item => item.id === this.menuselectedDirKeys[0])
            const pre = index === 0 ? '' : (this.currentMenuList[index - 1] && this.currentMenuList[index - 1].title)
            const next = index === (this.currentMenuList.length - 1) ? '' : (this.currentMenuList[index + 1] && this.currentMenuList[index + 1].title)
            this.$set(this.pageData, 'index', index)
            this.$set(this.pageData, 'pre', pre)
            this.$set(this.pageData, 'next', next)
        },
        // 翻页
        pageTurn (type) {
            if (type === 'pre') {
                const menu = this.currentMenuList[--this.pageData.index]
                menu.key = menu.id
                this.selectedMenuHandle(menu, true)
            } else {
                const menu = this.currentMenuList[++this.pageData.index]
                menu.key = menu.id
                this.selectedMenuHandle(menu, true)
            }
            if (this.isEditMode) {
                this.$refs.leftMenu && this.$refs.leftMenu.onMenuTreeSelect([this.currentMenu.id], {}, true)
            }
        },
        popUpdateDocDrawer () {
            this.$router.push('/update')
        },
        switchEditMode (flag) {
            this.isEditMode = flag
            if (flag) {
                this.modeConfig.defaultOpen = null
                this.modeConfig.subfield = true
                this.modeConfig.toolbarsFlag = true
                this.modeConfig.navigation = false
                this.modeConfig.boxShadow = true
                this.$nextTick(() => {
                    this.$refs.leftMenu && this.$refs.leftMenu.initData(this.currentMenu)
                })
            } else {
                this.modeConfig.defaultOpen = 'preview'
                this.modeConfig.subfield = false
                this.modeConfig.toolbarsFlag = false
                this.modeConfig.navigation = true
                this.modeConfig.boxShadow = false
                // this.getdbData()
            }
            this.getdbData()
        },
        submitFORM () {
            return false
        },
        getDirName () {
            this.$refs.editSubForm.validate((valid) => {
                if (valid) {
                    this.createDirForm = false
                    const keyList = this.selectedDirKey.slice(2).split('-')
                    keyList.reduce((accumulator, currentValue, index) => {
                        if (index === (keyList.length - 1)) {
                            const list = accumulator[Number(currentValue)].children
                            list.push({
                                title: this.dirForm.dirName,
                                key: this.selectedDirKey + '-' + list.length,
                                url: accumulator[Number(currentValue)].url + '\\' + this.dirForm.dirName,
                                children: []
                            })
                            this.addDirPath.push(accumulator[Number(currentValue)].url + '\\' + this.dirForm.dirName)
                        }
                        return accumulator[Number(currentValue)].children
                    }, this.dirTreeData)
                }
            })
        },
        saveImg () {
            this.$refs.selectImgDir.validate((valid) => {
                if (valid) {
                    const keyList = this.selectedDirKey.slice(2).split('-')
                    let imgimgPath = ''
                    keyList.reduce((accumulator, currentValue, index) => {
                        if (index === (keyList.length - 1)) {
                            imgimgPath = accumulator[Number(currentValue)].url
                        }
                        return accumulator[Number(currentValue)].children
                    }, this.dirTreeData)
                    const formdata = new FormData()
                    formdata.append('image', this.file)
                    formdata.append('path', imgimgPath)
                    formdata.append('addDirPath', this.addDirPath)
                    fetch(this.restUrl + '/upload', {
                        method: 'post',
                        body: formdata
                    }).then(response => response.json()).then((res) => {
                        this.addImgShow = false
                        // const url = window.location.protocol + '//' + window.location.host + '/' + res.data.url.replace(/\\/g, '/')
                        const url = '.' + res.data.url.replace(/\\/g, '/')
                        // 保存光标
                        const obj = this.$refs.md.getTextareaDom()
                        const startPos = obj.selectionStart
                        const endPos = obj.selectionEnd
                        // 保存滚动条位置
                        const vNoteEdit = this.$refs.md.$refs.vNoteEdit
                        const scrollTop = vNoteEdit.scrollTop
                        // 将返回的url替换到文本原位置![...](0) -> ![...](url)
                        this.$refs.md.$img2Url(this.pos, url)
                        setTimeout(() => {
                            obj.selectionStart = startPos + url.length
                            obj.selectionEnd = endPos + url.length
                            vNoteEdit.scrollTop = scrollTop
                        }, 1)
                        this.$refs.selectImgDir.resetFields()
                    })
                }
            })
        },
        dirNameReset () {
            this.$refs.dirForm.resetFields()
        },
        $imgAdd (pos, $file) {
            this.file = $file
            this.pos = pos
            fetch(this.restUrl + '/imagedir/info').then(response => response.json()).then(result => {
                this.addImgShow = true
                this.dirTreeData = result
            })
        },
        createDir () {
            this.createDirForm = true
        },
        onDirTreeSelect (selectedDirKey, info) {
            this.selectedDirKey = selectedDirKey[0]
        },
        exportSinglePDF () {
            fetch(this.restUrl + '/exportDoc/' + this.menuselectedDirKeys[0]).then(response => response.json()).then(result => {
                const htmlContent = []
                const toHtml = (data) => {
                    const { detail, children } = data
                    const content = this.$refs.md.markdownIt.render(Base64.decode(detail || ''))
                    htmlContent.push(`<div>${content}</div>`)
                    if (children) {
                        toHtml(children)
                    }
                }
                toHtml(result.data)
                const imgUrl = window.origin
                const html = `
                    <!DOCTYPE html>
                    <html lang="en">
                        <head>
                            <meta charset="UTF-8">
                            <meta name="viewport" content="width=device-width, initial-scale=1.0">
                            <meta http-equiv="X-UA-Compatible" content="ie=edge">
                            <title>Document</title>
                        </head>
                        <style>
                            body{font-family:'微软雅黑','PingFang SC', 'Helvetica Neue', 'Microsoft YaHei', Helvetica, 'Hiragino Sans GB', Arial, sans-serif;}
                            body img{ max-width: 100%; }
                        </style>
                        <body>
                            ${htmlContent.join('')}
                        </body>
                    </html>
                `.replaceAll('src="images', `src="${imgUrl}/images`)
                fetch(this.restUrl + '/exportPDF', {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
                    body: qs.stringify({
                        html: html,
                        name: result.data.title + '帮助文档' + new Date().getTime()
                    })
                }).then(response => response.json()).then(res => {
                    if (res.status && res.data) {
                        window.open(this.restUrl + '/download?url=' + res.data)
                    }
                }).catch(err => {
                    console.error(err)
                })
            })
        },
        exportPDF () {
            fetch(this.restUrl + '/exportDoc').then(response => response.json()).then(result => {
                const menu = []
                const map = {}
                result.data.forEach(m => {
                    m.children = []
                    map[m.id] = m // {1:菜单,2:菜单}
                    if (m.parentId === '0') {
                        menu.push(m) // 如果是根 就直接push到menu中
                    } else {
                        map[m.parentId] && map[m.parentId].children.push(m)
                    }
                })

                const htmlContent = []
                const toHtml = (data) => {
                    for (const i in data) {
                        const { title, detail, zIndex, children } = data[i]
                        const content = this.$refs.md.markdownIt.render(Base64.decode(detail || ''))
                        htmlContent.push(`<h${zIndex}>${title}</h${zIndex}><div>${content}</div>`)
                        if (children) {
                            toHtml(children)
                        }
                    }
                }
                toHtml(menu)
                const imgUrl = window.origin
                const html = `
                    <!DOCTYPE html>
                    <html lang="en">
                        <head>
                            <meta charset="UTF-8">
                            <meta name="viewport" content="width=device-width, initial-scale=1.0">
                            <meta http-equiv="X-UA-Compatible" content="ie=edge">
                            <title>Document</title>
                        </head>
                        <style>
                            body{font-family:'微软雅黑', 'PingFang SC', 'Helvetica Neue', 'Microsoft YaHei', Helvetica, 'Hiragino Sans GB', Arial, sans-serif;}
                            body img{ max-width: 100%; }
                        </style>
                        <body>
                            ${htmlContent.join('')}
                        </body>
                    </html>
                `.replaceAll('src="images', `src="${imgUrl}/images`)
                fetch(this.restUrl + '/exportPDF', {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
                    body: qs.stringify({
                        html: html,
                        name: '帮助文档' + new Date().getTime()
                    })
                }).then(response => response.json()).then(res => {
                    if (res.status && res.data) {
                        window.open(this.restUrl + '/download?url=' + res.data)
                    }
                }).catch(err => {
                    console.error(err)
                })
            })
        },
        getMenu (data, returnData, parent) {
            for (const i in data) {
                returnData.push({
                    title: data[i].title,
                    parentId: (parent && parent.id) || '0',
                    position: data[i].position,
                    zIndex: data[i].zIndex,
                    id: data[i].id
                })
                if (data[i].children) {
                    this.getMenu(data[i].children, returnData, data[i])
                }
            }
        },
        saveMarkdown () {
            // 是否需要全量更新，调整菜单顺序后菜单进行全量更新
            const menuHasChange = this.$refs.leftMenu && this.$refs.leftMenu.draged
            if (menuHasChange) {
                const newMenuData = (this.$refs.leftMenu && this.$refs.leftMenu.menuTreeData) || []
                const menu = []
                this.getMenu(newMenuData, menu)
                fetch(this.restUrl + '/update', {
                    method: 'PUT',
                    headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
                    body: qs.stringify({ menu: JSON.stringify(menu) })
                }).then(response => response.json()).then(result => {
                    this.$refs.leftMenu.draged = false
                })
            }

            fetch(this.restUrl + '/doc', {
                method: 'POST',
                headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
                body: qs.stringify({
                    id: this.menuselectedDirKeys[0],
                    data: Base64.encode(this.mdValue)
                })
            }).then(response => response.json()).then(result => {
                if (result.status) {
                    this.$message.success('数据保存成功！')
                }
            }).catch(err => {
                console.error(err)
            })
        }
    },
    watch: {
        '$route' (val) {
            this.getdbData()
        }
    }
}
</script>
<style lang="less">
@menu-item-height: 30px;
@menu-item-line-height: 24px;
@max-height: 54px;
.doc-nav-tree {
    .ant-menu-inline {
        border-right: 0;
    }
    .ant-menu-submenu-title {
        white-space: normal !important;
    }
    .ant-menu {
        background: none;
        font-size: 14px;
        .ant-menu-item {
            // height: @menu-item-height;
            max-height: @max-height;
            line-height: @menu-item-line-height;
            margin-bottom: 0 !important;
            font-size: 14px;
            height: auto;
            white-space: normal;
            overflow-wrap: break-word;
            -webkit-box-orient: vertical;
            -webkit-line-clamp: 2;
        }
        &:not(.ant-menu-horizontal) {
            .ant-menu-item-selected {
                background: none;
            }
        }
    }
    .ant-menu-submenu {
        .ant-menu-submenu-title {
            max-height: @max-height;
            // height: @menu-item-height !important;
            line-height: @menu-item-line-height !important;
            margin-bottom: 0 !important;
            font-size: 14px;
        }
        .ant-menu-sub {
            background: none;
            font-size: 14px;
            .ant-menu-item {
                max-height: @max-height;
                // height: @menu-item-height;
                line-height: @menu-item-line-height;
                margin-bottom: 0 !important;
            }
            .ant-menu-submenu-title {
                max-height: @max-height;
                // height: @menu-item-height !important;
                line-height: @menu-item-line-height !important;
                margin-bottom: 0 !important;
            }
        }
        .ant-menu-submenu-title {
            max-height: @max-height;
            height: auto !important;
            // height: @menu-item-height !important;
            line-height: @menu-item-line-height !important;
            margin-bottom: 0 !important;
            overflow-wrap: break-word;
            -webkit-box-orient: vertical;
            -webkit-line-clamp: 2;
        }
    }
    .ant-menu-item-selected {
        background: none;
        font-weight: 600;
        &::after {
            border-right: 0 !important;
        }
    }
}
.markdown-body {
    font-family: '微软雅黑', 'PingFang SC', 'Helvetica Neue', 'Microsoft YaHei', Helvetica, 'Hiragino Sans GB', Arial,
        sans-serif;
    border: 0 !important;
    .v-show-content {
        padding: 20px 300px 20px 40px !important;
        background: none !important;
    }
    h2 {
        font-size: 24px;
    }
    h2 {
        font-size: 22px;
    }
    h3 {
        font-size: 20px;
    }
    h4 {
        font-size: 18px;
    }
    p {
        font-size: 16px;
        img {
            width: 70%;
        }
    }
    ul,
    ol {
        font-size: 15px;
    }
    .v-note-img-wrapper {
        img {
            width: 80%;
        }
    }
    .v-show-content {
        padding-top: 0px !important;
    }
    .v-note-panel {
        width: 100%;
        .v-note-navigation-close {
            display: none !important;
        }
    }
    .v-note-navigation-wrapper {
        width: 240px !important;
        right: 10px !important;
        h1,
        h2,
        h3,
        h4,
        h5 {
            font-weight: 400 !important;
            margin: 5px 0 !important;
            color: #999 !important;
            text-overflow: unset !important;
            word-wrap: wrap !important;
            white-space: wrap !important;
            overflow-wrap: break-word !important;
            -webkit-box-orient: vertical !important;
            -webkit-line-clamp: 2;
            strong {
                font-weight: 400 !important;
            }
            &:hover {
                color: #c7000a !important;
                // color: #144480 !important;
            }
        }
        h1 {
            font-size: 16px !important;
        }
        h2 {
            font-size: 15px !important;
        }
        h3 {
            font-size: 14px !important;
        }
        h4 {
            font-size: 13px !important;
        }
        h5 {
            font-size: 12px !important;
        }
    }
}
.ant-btn-primary {
    color: #fff !important;
}
.markdown-footer {
    .ant-btn-link {
        color: #c7000a !important;
    }
}
</style>
<style lang="less" scoped>
.layout-container {
    width: 100%;
    height: 100%;
    display: flex;
    .layout-nav {
        position: relative;
        width: 250px;
        overflow: hidden;
        height: 100%;
        border-right: 1px solid #e4e6f3;
        // background: #f2f5fc;
        .doc-nav-title {
            position: relative;
            width: 100%;
            height: 50px;
            font-size: 16px;
            color: #3d3f43;
            line-height: 50px;
            padding-left: 15px;
            border-bottom: 1px solid #e4e6f3;
            transition: all 0.3s;
            font-weight: 700;
            .menu-edit-icon,
            .menu-export-icon {
                position: absolute;
                right: 15px;
                top: 18px;
                cursor: pointer;
                &:hover {
                    color: #0099d7;
                }
            }
        }
        .doc-nav-tree {
            width: 100%;
            padding: 5px 0 5px 10px;
            font-size: 14px;
            overflow: hidden;
            // &:hover {
            //     overflow-y: auto;
            // }
            .doc-nav-search {
                padding-top: 5px;
                padding-right: 10px;
            }
            .doc-nav-menu {
                height: calc(~'100% - 24px');
                overflow-y: hidden;
                &:hover {
                    overflow-x: hidden;
                    overflow-y: auto;
                }
                /* // 自定义滚动条 */
                &::-webkit-scrollbar {
                    width: 6px;
                    max-height: 50px;
                    border-radius: 50%;
                    margin-right: 16px;
                }

                /* // 定义滚动条轨道 */
                &::-webkit-scrollbar-track {
                    background-color: transparent !important;
                    /* // display: none; */
                }

                /* // 内轨道部分 */
                &::-webkit-scrollbar-thumb {
                    border-radius: 5px;
                    background-color: #d7d7d7 !important;
                }

                &::-webkit-scrollbar-thumb:hover {
                    cursor: pointer;
                    /* background-color: #365466 !important; */
                }
            }
        }
    }
    .layout-content {
        width: calc(~'100% - 250px');
        height: 100%;
        // display: inline-block;
        .custom-markdown {
            width: 100%;
            height: 100%;
            .custom-breadcrumbs {
                background: #fff;
                z-index: 10000;
                width: 100%;
                height: 50px;
                font-size: 14px;
                display: flex;
                align-items: center;
                // border-bottom: 1px solid #e9e9e9;
                padding: 0 15px;
                .custom-breadcrumb {
                    width: 50%;
                    height: 100%;
                    display: flex;
                    align-items: center;
                }
                .edit-panel {
                    width: 50%;
                    height: 100%;
                    position: relative;
                    display: flex;
                    align-items: center;
                    justify-content: flex-end;
                    /deep/ .ant-btn-link {
                        color: #c7000a;
                    }
                }
            }
            .markdown-container {
                // position: absolute;
                // margin-top: 50px;
                z-index: 1000;
                width: 100%;
                height: 100%;
                // overflow: auto;
                overflow: hidden;
                height: calc(~'100% - 50px');
                // padding: 0 20px;
                .markdown-body {
                    width: 100%;
                    height: calc(~'100% - 50px');
                }
                .markdown-footer {
                    display: flex;
                    align-items: center;
                    justify-content: space-between;
                    color: #333;
                    border-top: 1px solid #e9e9e9;
                    height: 49px;
                    line-height: 50px;
                    a-button {
                        color: #333;
                    }
                }
            }
        }
    }
    .marginbot20 {
        margin-bottom: 20px !important;
    }
}
</style>
<style lang="less">
.layout-nav {
    .ant-menu-inline {
        line-height: 53px;
        border-bottom: 0px;
        > .ant-menu-item-active {
            color: #c7000a;
            border-bottom: 0px !important;
        }
        > .ant-menu-submenu-active {
            color: #c7000a !important;
            border-bottom: 0px !important;
        }
        > .ant-menu-item {
            border-bottom: 0px !important;
            &:hover {
                color: #c7000a !important;
            }
        }
    }
    .ant-menu-submenu-inline {
        .ant-menu-submenu-arrow {
            color: #c7000a !important;
        }
    }
    .ant-menu-root > li.ant-menu-submenu-inline > .ant-menu-submenu-title > .ant-menu-submenu-arrow {
        left: 10px !important;
    }
    .ant-menu-root > li.ant-menu-submenu-inline:not(.ant-menu-submenu-open),
    .ant-menu-root > li.ant-menu-submenu-open {
        > .ant-menu-sub {
            .ant-menu-submenu-inline {
                .ant-menu-submenu-arrow {
                    left: 35px !important;
                }
            }
        }
    }
    .ant-menu-root > li.ant-menu-submenu-inline:not(.ant-menu-submenu-open),
    .ant-menu-root > li.ant-menu-submenu-open {
        > ul.ant-menu-sub {
            .ant-menu-submenu-inline {
                > ul.ant-menu-sub {
                    .ant-menu-submenu-inline {
                        .ant-menu-submenu-arrow {
                            left: 58px !important;
                        }
                    }
                }
            }
        }
    }

    .ant-menu-submenu .ant-menu-submenu-active,
    .ant-menu-submenu-title:hover {
        color: #c7000a !important;
        .ant-menu-submenu-arrow::before {
            background: #c7000a !important;
            color: #c7000a !important;
        }
        .ant-menu-submenu-arrow::after {
            background: #c7000a !important;
            color: #c7000a !important;
        }
    }
    .ant-menu-submenu-selected {
        color: #c7000a !important;
    }
    .ant-menu-item-selected {
        color: #c7000a !important;
    }
}
.ant-modal-mask,
.ant-modal-wrap {
    z-index: 9999;
}
</style>
